import { render, staticRenderFns } from "./jkmh.vue?vue&type=template&id=7979f88c&scoped=true&"
import script from "./jkmh.vue?vue&type=script&lang=js&"
export * from "./jkmh.vue?vue&type=script&lang=js&"
import style0 from "./jkmh.vue?vue&type=style&index=0&id=7979f88c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7979f88c",
  null
  
)

export default component.exports